import { render, staticRenderFns } from "./SubList.vue?vue&type=template&id=30aff70a&scoped=true"
import script from "./SubList.vue?vue&type=script&lang=js"
export * from "./SubList.vue?vue&type=script&lang=js"
import style0 from "./SubList.vue?vue&type=style&index=0&id=30aff70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aff70a",
  null
  
)

export default component.exports